/*
 * Copyright (c) 2004-2019 Paul Blacknell. All rights reserved.
 * https://github.com/blacknell
 */

import React, {Component} from 'react';
import { Remarkable } from 'remarkable';
import axios from 'axios';
import ReactGA from 'react-ga';

class Welcome extends Component {
    // eslint-disable-next-line no-useless-constructor
    constructor(props) {
        super(props);

        this.state = {
            welcome: '',
        }
    }

    componentDidMount() {

        var md = new Remarkable();

        axios.get(
            '/welcome.md',
            {
                timeout: 5000,
            }).then(res => {
            this.setState({welcome: md.render(res.data)});
        }).catch(async function(error) {
            if (error.response) {
                ReactGA.event({
                    category: 'Errors',
                    action: 'remarkable.get',
                    label: `Response - ${error.response.status}`,
                    nonInteraction: true,
                });
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.warn(error.response.status);
                console.warn(error.response.headers);
            } else if (error.request) {
                ReactGA.event({
                    category: 'Errors',
                    action: 'remarkable.get',
                    label: `Request - ${error.message}`,
                    nonInteraction: true,
                });
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.error(error.request);
            } else {
                ReactGA.event({
                    category: 'Errors',
                    action: 'remarkable.get',
                    label: `Error - ${error.message}`,
                    nonInteraction: true,
                });
                // Something happened in setting up the request that triggered an Error
                console.error( error.message);
            }
        });

    }

    render() {
        return (<div className='flex flex-column flex-start flex-nowrap align-items-center align-content-start'
                     dangerouslySetInnerHTML={{__html:this.state.welcome}}></div>);
    }
}

export default Welcome;